Vendd.Scripts.load(function () {
    
    var funcCookiesEnabled = true;
    if (window.ConsentsManager) {
        funcCookiesEnabled = window.ConsentsManager.cookiesStatus.functionalityCookies;
    }

    var $new_visitor_popup = $('.js-customer-popup');

    if ($new_visitor_popup.length < 1 || !funcCookiesEnabled)
        return;

    var wrapper = $new_visitor_popup.get(0);
    var hasOrders;
    var latestOrders;

    /* If there is a customer username greet him with his/her name. Username is saved during login (loginWidget.js) */
    var visitor_name = Lockr.get('username');
    if (visitor_name !== undefined) {
        $new_visitor_popup.find('.js-new-customer').hide();
        $new_visitor_popup.find('.js-returning-customer').append(' ' + visitor_name).show();
    }

    wrapper.initNewVisitorPopup = function() {
        $new_visitor_popup.on( 'click', '.js-login', function ( e ) {
            e.preventDefault();
            $.fancybox.close();
            $('.x-login-widget .js-widget-trigger').trigger('click');
        } );
    
        $new_visitor_popup.on( 'click', '.js-continue', function ( e ) {
            e.preventDefault();
            $.fancybox.close();
        } );

        $.fancybox.open($new_visitor_popup,{
            touch : {
                vertical : false,  // Allow to drag content vertically
                momentum : false   // Continue movement after releasing mouse/touch when panning
            },
        });
    };

    wrapper.initNewOrderPopup = function () {
        $new_visitor_popup.find('.logo').hide();
        $new_visitor_popup.find('.title').hide();
        $new_visitor_popup.find('.js-login').hide();
        $new_visitor_popup.find('.subtitle').addClass('main-title');
        $new_visitor_popup.find('.order-start').show();
        if (!hasOrders) {
            $new_visitor_popup.find('.order-start-img').show();
        }
        wrapper.initNewVisitorPopup();
    };

    /* Display welcoming PopUp once per day*/
    var returning_customer = Cookies.get('returning_customer');
    if (returning_customer === '') {
        Cookies.set('returning_customer', 'true', { expires: 1, samesite: 'Lax' });
        wrapper.initNewVisitorPopup();
    }
    
    $(document).ready(function () {
        $('.js-new-order').click(function (e) { 
            e.preventDefault();
            if (document.location.href.indexOf('new-order') == -1) {
                Lockr.set('url',document.location.href);
            }
            wrapper.initNewOrderPopup();
        });
    });

    wrapper.addLatestOrders = function(orders) {
        $orders_wrapper = $new_visitor_popup.find('.inner-area-two');
        if (orders.length > 0) {
            hasOrders = true;
            var parsedHtml = Vendd.Handlebars.parse('customerPopupOrders', orders);
            $new_visitor_popup.find('.order-start').hide();
            $orders_wrapper.find('ul').append(parsedHtml);
            $orders_wrapper.show();
        }

        var getSelectedOrderItems = function ($wrapper) {
            var OrderItemsToAdd = [];
            $('.order-product-item', $wrapper).each(function () {
                  var reOrderItem = {
                      Id: $(this).attr('data-id'),
                      Quantity: $(this).attr('data-quantity')
                  };
                  OrderItemsToAdd.push(reOrderItem);
            });
            
            return OrderItemsToAdd;
        };

        $('.add-all-to-cart').on('click', function (e) {
            e.preventDefault();

            orderIdToAdd = $(this).closest('.x-order-box').data('orderid');
            orderItemsToAdd = getSelectedOrderItems($(this).closest('.x-order-box'));

            var data = {
                orderId: orderIdToAdd,
                orderSelectedItems: JSON.stringify(orderItemsToAdd),
                clearCart: true
            };
            Vendd.MessageBus.publishAsync(wrapper, new Vendd.Cart.Messages.AddOrderItemsToCart(data));
            $.fancybox.close();
            //Get Order Address
            $.each(latestOrders, function (i, el) { 
                 if (el.OrderId == orderIdToAdd) {
                    city = el.ShippingAddress.City;
                    area = el.ShippingAddress.City;
                    street = el.ShippingAddress.Area;
                    streetNumber = el.ShippingAddress.AddressLine1;
                    postalCode = el.ShippingAddress.PostCode;
                    floor = el.ShippingAddress.AddressLine2;
                    bell = el.ShippingAddress.Bell;
                 }
            });
            // $.ajax({
            //     type: "post",
            //     async: false,
            //     url: "/Services/api/StreetAddress/ResolvePartnerWarehouseByAdress",
            //     data: {
            //         city: city,
            //         area: area,
            //         street: street,
            //         streetNumber: streetNumber,
            //         postalCode: postalCode,
            //         floor: floor,
            //         bell: bell
            //     },
            //     dataType: "json",
            //     statusCode: {
            //         200: function (response) {
            //             $.ajax({
            //                 type: "post",
            //                 url: "/Services/api/DeliveryPoint/SetDeliveryPoint",
            //                 data: {
            //                     deliveryPointId: deliveryPointId
            //                 },
            //                 dataType: "json",
            //                 statusCode: {
            //                     200: function (response) {
            //                         //Show Delivery widget
            //                         Vendd.MessageBus.publish($('.x-deliverypoint-widget').get(0), new Vendd.DeliveryPoint.Messages.GetModel());
            //                     },
            //                     404: function (response) {
                
                
            //                     },
            //                     500: function (response) {
                
            //                     }
            //                 }
            //             });
            //         },
            //         404: function (response) {
            //             saved = false;
            //         },
            //         500: function (response) {
            //             saved = false;
            //         }
            //     }
            // });
            
            //Open the widget only for template 1 of Cart Widget
            if ($('.x-cart-widget').data('template') === 1) {
                Vendd.MessageBus.publishAsync($wrapper, new Vendd.Widget.Messages.OpenWidget(Vendd.Widget.CartWidget, false));
            }

        }); 
    };

    //Get authenticated status and hide Log In pane
    Vendd.MessageBus.subscribe(Vendd.User.Messages.GetUserViewModelSuccess, wrapper, function (envelope) {
        model = envelope.message.data.model;
        if (model.IsAuthenticated) {
            //Get latest orders
            $.ajax({
                type: "post",
                url: "/Services/api/Account/GetLatestOrders",
                success: function (response) {
                    wrapper.addLatestOrders(response.data.Orders);
                    latestOrders = response.data.Orders;
                }
            });
        } 
    });
});

